/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React, { useEffect, useState } from "react";
import { Collapse, message } from "antd";
import RateMatrixTable from "./RateMatrixTable";
import API from "../../../api";
import urls from "../../../api/urls";
const { GET_DEFAULT_RATE_CARD } = urls;
const RateMatrix = ({ rateMatrixData, quotationRateMatrix, templateType }) => {
  const { Panel } = Collapse;
  const [standardDoxSurface, setStandardDoxSurface] = useState([]);
  const [standardDoxAir, setStandardDoxAir] = useState([]);
  const [standardNonDoxSurface, setStandardNonDoxSurface] = useState([]);
  const [standardNonDoxAir, setStandardNonDoxAir] = useState([]);
  const [fastTrackSurface, setFastTrackSurface] = useState([]);
  const [fastTrackAir, setFastTrackAir] = useState([]);
  const [fastTrackNonDoxSurface, setFastTrackNonDoxSurface] = useState([]);
  const [fastTrackNonDoxAir, setFastTrackNonDoxAir] = useState([]);
  const [valuePlusDoxSurface, setValuePlusDoxSurface] = useState([]);
  const [valuePlusDoxAir, setValuePlusDoxAir] = useState([]);
  const [valuePlusNonDoxSurface, setValuePlusNonDoxSurface] = useState([]);
  const [valuePlusNonDoxAir, setValuePlusNonDoxAir] = useState([]);

  useEffect(() => {
    getDefaultRate();
  }, [quotationRateMatrix]);

  const getDefaultRate = async () => {
    try {
      let data = {};
      const res = await API.Api(GET_DEFAULT_RATE_CARD).get();
      if (res?.status) {
        data = res?.response?.data;
        if (Object.keys(quotationRateMatrix)?.length > 0) {
          data = quotationRateMatrix;
        }
      } else {
        message.error(res?.response?.data?.message || "Internal server error.");
      }

      setStandardDoxSurface(transformArray(data?.dox?.surface?.standard));
      setStandardDoxAir(transformArray(data?.dox?.air?.standard));
      setStandardNonDoxSurface(transformArray(data?.nonDox?.surface?.standard));
      setStandardNonDoxAir(transformArray(data?.nonDox?.air?.standard));

      setFastTrackAir(transformArray(data?.dox?.air?.fastTrack));
      setFastTrackSurface(transformArray(data?.dox?.surface?.fastTrack));
      setFastTrackNonDoxAir(transformArray(data?.nonDox?.air?.fastTrack));
      setFastTrackNonDoxSurface(
        transformArray(data?.nonDox?.surface?.fastTrack)
      );

      setValuePlusDoxSurface(transformArray(data?.dox?.surface?.valuePlus));
      setValuePlusDoxAir(transformArray(data?.dox?.air?.valuePlus));
      setValuePlusNonDoxSurface(
        transformArray(data?.nonDox?.surface?.valuePlus)
      );
      setValuePlusNonDoxAir(transformArray(data?.nonDox?.air?.valuePlus));
    } catch (error) {
      message.error("An error occurred while fetching data.");
    }
  };

  useEffect(() => {
    rateMatrixData({
      standardDoxSurface,
      standardDoxAir,
      standardNonDoxSurface,
      standardNonDoxAir,
      fastTrackSurface,
      fastTrackAir,
      fastTrackNonDoxSurface,
      fastTrackNonDoxAir,
      valuePlusDoxSurface,
      valuePlusDoxAir,
      valuePlusNonDoxSurface,
      valuePlusNonDoxAir,
    });
  }, [
    standardDoxSurface,
    standardDoxAir,
    standardNonDoxSurface,
    standardNonDoxAir,
    fastTrackSurface,
    fastTrackAir,
    fastTrackNonDoxSurface,
    fastTrackNonDoxAir,
    valuePlusDoxSurface,
    valuePlusDoxAir,
    valuePlusNonDoxSurface,
    valuePlusNonDoxAir,
  ]);

  const transformArray = (array) =>
    array?.map((obj) => ({
      title: `Up to ${obj.maxValue || obj.volume} Gms`,
      design: obj.volume,
      minValue: obj.minValue,
      value: [
        { title: "LOCAL", value: (obj.local || 0).toFixed(2) },
        { title: "WITHIN STATE", value: (obj.withinZone || 0).toFixed(2) },
        { title: "My Zone 1", value: (obj.myZone1 || 0).toFixed(2) },
        { title: "My Zone 2", value: (obj.myZone2 || 0).toFixed(2) },
        { title: "My Zone 3", value: (obj.myZone3 || 0).toFixed(2) },
        { title: "My Zone 4", value: (obj.myZone4 || 0).toFixed(2) },
        { title: "METRO", value: (obj.metro || 0).toFixed(2) },
        {
          title: "SPECIAL LOCATION",
          value: (obj.specialLocation || 0).toFixed(2),
        },
        { title: "REST OF INDIA", value: (obj.roi || 0).toFixed(2) },
      ],
    }));

  const setWeightSlabData = (data, title) => {
    switch (title) {
      case "standardDocsSurface":
        setStandardDoxSurface(data);
        break;
      case "standardDocsAir":
        setStandardDoxAir(data);
        break;
      case "standardNonDocsSurfce":
        setStandardNonDoxSurface(data);
        break;
      case "standardNonDocsAir":
        setStandardNonDoxAir(data);
        break;
      case "fastTrackSurface":
        setFastTrackSurface(data);
        break;
      case "fastTrackAir":
        setFastTrackAir(data);
        break;
      case "fastTrackNonDoxSurface":
        setFastTrackNonDoxSurface(data);
        break;
      case "fastTrackNonDoxAir":
        setFastTrackNonDoxAir(data);
        break;
      case "valuePlusDoxSurface":
        setValuePlusDoxSurface(data);
        break;
      case "valuePlusDoxAir":
        setValuePlusDoxAir(data);
        break;
      case "valuePlusNonDoxSurface":
        setValuePlusNonDoxSurface(data);
        break;
      case "valuePlusNonDoxAir":
        setValuePlusNonDoxAir(data);
        break;
    }
  };

  const changeDynamicSelect = (title, data) => {
    switch (title) {
      // case "standardNonDocs":
      //   setStandardNonDox(data);
      //   break;
      // case "fastTrackNonDox":
      //   setFastTrackNonDox(data);
      //   break;
      // case "valueplusNonDox":
      //   setValuePlusNonDox(data);
      //   break;
      case "standardNonDocsSurfce":
        setStandardNonDoxSurface(data);
        break;
      case "standardNonDocsAir":
        setStandardNonDoxAir(data);
        break;
      case "fastTrackNonDoxSurface":
        setFastTrackNonDoxSurface(data);
        break;
      case "fastTrackNonDoxAir":
        setFastTrackNonDoxAir(data);
        break;
      case "valuePlusNonDoxSurface":
        setValuePlusNonDoxSurface(data);
        break;
      case "valuePlusNonDoxAir":
        setValuePlusNonDoxAir(data);
        break;
    }
  };

  return (
    <div>
      <Collapse collapsible={"header"} defaultActiveKey={["2"]}>
        <Panel header="Rate Matrix" key="2">
          <RateMatrixTable
            standardDocsSurfaceData={standardDoxSurface}
            standardDocsAirData={standardDoxAir}
            standardNonDocsSurfceData={standardNonDoxSurface}
            standardNonDocsAirData={standardNonDoxAir}
            fastTrackSurfaceData={fastTrackSurface}
            fastTrackAirData={fastTrackAir}
            fastTrackNonDoxAirData={fastTrackNonDoxAir}
            fastTrackNonDoxSurfaceData={fastTrackNonDoxSurface}
            valuePlusDoxSurfaceData={valuePlusDoxSurface}
            valuePlusDoxAirData={valuePlusDoxAir}
            valuePlusNonDoxSurfaceData={valuePlusNonDoxSurface}
            valuePlusNonDoxAirData={valuePlusNonDoxAir}
            handleChangeDocs={(e, data) => setWeightSlabData(e, data)}
            handleDynamicSelect={(data, title) =>
              changeDynamicSelect(data, title)
            }
            templateType={templateType}
          />
        </Panel>
      </Collapse>
    </div>
  );
};
export default RateMatrix;
